import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "./baseUrl";
import ProductCard from "./ProductCard";

function ShopByCar(props) {
  const [shopProduct, setShopProduct] = useState([]);
  const [brands, setBrands] = useState([]);
  const [heading, setHeading] = useState(false);
  const [FilterName, setFN] = useState({ brand: [], model: [] });
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [Visible, setVisible] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  useEffect(() => {
    fetchShopProductData();
  }, [props.match.params.bId, props.match.params.mId]);

  useEffect(() => {
    applyingFilterAPI();
  }, [model]);

  useEffect(() => {
    getBrands();
  }, []);

  //===================== fetch product data ===============
  const fetchShopProductData = async () => {
    const selectedWorkingStateId = localStorage.getItem("selectedWorkingStateId");
    const wsId = selectedWorkingStateId ? selectedWorkingStateId : "";
    try {
      let ProductData;
      if (typeof props.match.params.bId !== "undefined") {
        if (typeof props.match.params.mId === "undefined") {
          ProductData = await axios.get(`${baseUrl}Apicontroller/get_rel_products`, {
            params: {
              b_id: props.match.params.bId,
              s_id: wsId,
            },
          });
        } else {
          ProductData = await axios.get(`${baseUrl}Apicontroller/get_rel_products`, {
            params: {
              b_id: props.match.params.bId,
              m_id: props.match.params.mId,
              s_id: wsId,
            },
          });
        }
      } else {
        ProductData = await axios.get(`${baseUrl}Apicontroller/get_rel_products`, {
          params: {
            s_id: wsId,
          },
        });
      }
      if (ProductData.data.status === 200) {
        setHeading(ProductData.data.heading);
        setShopProduct(ProductData.data.data);
        setCurrentPage(1); // Reset page to 1 on new data load
      }
    } catch (e) {
      console.log("Issue in get product detail.", e);
    }
  };

  //=========================== fetch filter data======================
  const getBrands = async () => {
    try {
      let response = await axios.get(baseUrl + "Apicontroller/get_brands");
      if (response.data.status === 200) {
        setBrands(response.data.data);
      }
    } catch {
      console.log("Issue in get category.");
    }
  };

  ///========================set filter ==================
  const setFilters = (e) => {
    const filterId = e.target.getAttribute("filterid");
    const filterName = e.target.getAttribute("filtername");
    if (filterName === "model") {
      if (e.target.checked) {
        if (model === "") {
          setModel(filterId);
        } else {
          let newdata = model + "," + filterId;
          setModel(newdata);
        }
      } else {
        if (model !== "") {
          let prevArray = model.split(",");
          let index = prevArray.indexOf(filterId);
          if (index > -1) {
            prevArray.splice(index, 1);
          }
          let newdata = prevArray.join();
          setModel(newdata);
        }
      }
    }
  };

  //====================== apply filter ===========================
  const applyingFilterAPI = async () => {
    if (model !== "") {
      const appliedFilterData = new FormData();
      appliedFilterData.append("model", model);
      const workingState = localStorage.getItem("selectedWorkingStateId");
      const wsId = workingState ? workingState : "";
      appliedFilterData.append("w_s_id", wsId);
      try {
        const response = await axios.post(baseUrl + "Apicontroller/filter", appliedFilterData);
        if (response.data.status === 201) {
          setShopProduct([]);
        } else {
          setHeading("Showing Filter Results");
          setShopProduct(response.data.data);
          setCurrentPage(1); // Reset page on new filtered data
        }
      } catch {
        console.log("Issue in get filtered data");
      }
    } else {
      fetchShopProductData();
    }
  };

  //================================show filter ===================
  const openFilter = () => {
    document.querySelector(".side_filter").style.transform = "translateX(0px)";
  };

  //================================close filter ===================
  const closeFilter = () => {
    document.querySelector(".side_filter").style.transform = "translateX(900px)";
  };

  // ==== Pagination Logic ====
  const totalPages = Math.ceil(shopProduct.length / itemsPerPage);

  // Generate page numbers with ellipsis for large pages
  const getPageNumbers = () => {
    const delta = 2; // how many pages before and after current
    const range = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      } else if (
        (i === currentPage - delta - 1 && i > 1) ||
        (i === currentPage + delta + 1 && i < totalPages)
      ) {
        range.push("...");
      }
    }
    // Remove duplicate ellipsis
    return range.filter((item, pos, arr) => {
      return item !== "..." || arr[pos - 1] !== "...";
    });
  };

  const pages = getPageNumbers();

  // Get only the products for current page
  const currentProducts = shopProduct.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Pagination button handlers
  const goToPage = (page) => {
    if (page === "...") return;
    setCurrentPage(page);
    window.scrollTo(0, 0); // scroll to top on page change
  };

  const goFirst = () => setCurrentPage(1);
  const goLast = () => setCurrentPage(totalPages);
  const goPrev = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
  const goNext = () => setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));

  return (
    <div>
      <section className="filter_img pt-5 mt-5">
        <div className="container-fluid px-5 mob-viewpaddding">
          <div className="row heading-div">
            <div className="col-md-12 text-center">
              {heading === "All Car Products" ? (
                <h1 id="heading" className="heading">
                  {heading}
                </h1>
              ) : (
                <h1 id="heading" className="heading"> {heading} Accessories</h1>
              )}
            </div>
          </div>
          {/* Mob view toggle filter */}
          <div className="d-block d-md-none">
            <div className="row d-flex text-right justify-content-end mb-2">
              <div
                className="col-5 py-2 d-flex text-right border justify-content-end"
                onClick={() => {
                  openFilter();
                }}
                style={{ cursor: "pointer" }}
              >
                <div>
                  <p className="mb-0">Filters</p>
                </div>
                <div>
                  <i className="fa fa-filter px-2" style={{ fontSize: "1.4rem" }}></i>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-12 p-2 border d-none d-md-block">
              {/* Web view filters */}
              <div className="">
                <div className={"mb-2"}>
                  <div className="text-center">
                    <p className="mb-0" style={{ color: "black", fontWeight: "bold" }}>
                      Filters
                    </p>
                  </div>
                </div>
                <div className="accordion filter_shopbycar" id="filter_shopbycar">
                  {brands
                    ? brands.map((x) => {
                        return (
                          <div className="card" key={x.id}>
                            <div className="card-header shopBycar" id={x.name}>
                              <h2
                                className="mb-0 d-flex w-100"
                                style={{ justifyContent: "space-around" }}
                                role="button"
                                data-toggle="collapse"
                                data-target={"#collapse" + x.id}
                                aria-expanded="true"
                                aria-controls={"#collapse"}
                              >
                                <span
                                  style={{ fontSize: "1rem", margin: "auto", marginLeft: "0px" }}
                                  className="d-block"
                                >
                                  {x.name}
                                </span>
                                <button
                                  className="btn btn-link w-50 ml-auto text-end"
                                  type="button"
                                  style={{ textAlign: "end" }}
                                >
                                  <i className="fa fa-chevron-circle-down"></i>
                                </button>
                              </h2>
                            </div>
                            <div
                              id={"collapse" + x.id}
                              className="collapse"
                              aria-labelledby={"heading"}
                              data-parent="#filter_shopbycar"
                            >
                              <div className="card-body shopBycar_item">
                                <ul
                                  style={{ fontSize: "20px" }}
                                  className="pl-0 mt-0 mb-0 mt-2"
                                >
                                  {x
                                    ? x.car_model.map((elem, i) => {
                                        return (
                                          <li
                                            style={{ fontSize: "16px", transform: "none" }}
                                            key={elem.id}
                                          >
                                            <input
                                              type="checkbox"
                                              name="name"
                                              id={elem.id}
                                              className="CheckShopbycar"
                                              filterid={elem.id}
                                              filtername="model"
                                              onClick={(e) => setFilters(e)}
                                            />
                                            <label htmlFor={elem.id} className="mx-2 m-0">
                                              {elem.name}
                                            </label>
                                          </li>
                                        );
                                      })
                                    : ""}
                                </ul>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
              </div>
            </div>
            <div className="col-md-9 col-12 p-0 px-2">
              {shopProduct.length > 0 ? (
                <>
                  <div className="row">
                    {currentProducts.map((elem, i) => {
                      return (
                        <ProductCard
                          key={elem.product_id || i}
                          product_id={elem.product_id}
                          productimage={elem.image ? elem.image : elem.product_image}
                          productname={elem.product_name}
                          mrp={elem.mrp ? elem.mrp : elem.MRP}
                          price={elem.price}
                          addingToCartFunction={props.addingToCart}
                          isSlider="false"
                        />
                      );
                    })}
                  </div>

                  {/* Pagination UI */}
                  <div className="row mt-4">
                    <div className="col-12 d-flex justify-content-center align-items-center flex-wrap">
                      <button
                        className="btn btn-sm btn-outline-primary m-1"
                        onClick={goFirst}
                        disabled={currentPage === 1}
                      >
                        First
                      </button>
                      <button
                        className="btn btn-sm btn-outline-primary m-1"
                        onClick={goPrev}
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>

                      {pages.map((page, idx) =>
                        page === "..." ? (
                          <span key={"ellipsis_" + idx} className="mx-2">
                            ...
                          </span>
                        ) : (
                          <button
                            key={page}
                            className={`btn btn-sm m-1 ${
                              currentPage === page ? "btn-primary" : "btn-outline-primary"
                            }`}
                            onClick={() => goToPage(page)}
                          >
                            {page}
                          </button>
                        )
                      )}

                      <button
                        className="btn btn-sm btn-outline-primary m-1"
                        onClick={goNext}
                        disabled={currentPage === totalPages || totalPages === 0}
                      >
                        Next
                      </button>
                      <button
                        className="btn btn-sm btn-outline-primary m-1"
                        onClick={goLast}
                        disabled={currentPage === totalPages || totalPages === 0}
                      >
                        Last
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="w-100 text-center mt-5">
                  <h5>No Data Found!</h5>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Apply filter mobile view */}
      <section className="side_filter d-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <span
                className="close_side d-flex text-white"
                style={{ fontSize: "1.5rem" }}
                onClick={() => {
                  closeFilter();
                }}
              >
                X
              </span>
            </div>
            <div className="col-12 p-0 mt-5 pt-2">
              <div className="accordion filter_shopbycar" id="filter_shopbycar">
                {brands
                  ? brands.map((x) => {
                      return (
                        <div className="card" key={x.id}>
                          <div className="card-header shopBycar" id={x.name}>
                            <h2
                              className="mb-0 d-flex w-100"
                              style={{ justifyContent: "space-around" }}
                              role="button"
                              data-toggle="collapse"
                              data-target={"#collapse" + x.id}
                              aria-expanded="true"
                              aria-controls={"#collapse"}
                            >
                              <span
                                style={{ fontSize: "1rem", margin: "auto", marginLeft: "0px" }}
                                className="d-block"
                              >
                                {x.name}
                              </span>
                              <button
                                className="btn btn-link w-50 ml-auto text-end"
                                type="button"
                                style={{ textAlign: "end" }}
                              >
                                <i className="fa fa-chevron-circle-down"></i>
                              </button>
                            </h2>
                          </div>
                          <div
                            id={"collapse" + x.id}
                            className="collapse"
                            aria-labelledby={"heading"}
                            data-parent="#filter_shopbycar"
                          >
                            <div className="card-body shopBycar_item">
                              <ul style={{ fontSize: "20px" }} className="pl-0 mt-0 mb-0 mt-2">
                                {x
                                  ? x.car_model.map((elem, i) => {
                                      return (
                                        <li style={{ fontSize: "16px", transform: "none" }} key={elem.id}>
                                          <input
                                            type="checkbox"
                                            name="name"
                                            id={elem.id}
                                            className="CheckShopbycar"
                                            filterid={elem.id}
                                            filtername="model"
                                            onClick={(e) => setFilters(e)}
                                          />
                                          <label htmlFor={elem.id} className="mx-2 m-0">
                                            {elem.name}
                                          </label>
                                        </li>
                                      );
                                    })
                                  : ""}
                              </ul>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ShopByCar;
